import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import {
  CollateralSpecificMatch,
  CollateralTypeDto,
  CollateralTypesToDisplay,
  LegalEntitySelectionChangeEvent,
  LocateMatch,
} from '../../models';
import { SgEntityBasedSession } from '../../misc';

@Component({
  selector: 'sg-units-cell',
  templateUrl: './units-cell.component.html',
  styleUrls: ['./units-cell.component.scss'],
  standalone: false,
})
export class SgUnitsCellComponent implements OnInit {
  @Input()
  get locateMatch(): LocateMatch {
    return this._locateMatch;
  }
  set locateMatch(value: LocateMatch) {
    this.setValidationErrorMessages(value);
    this._locateMatch = value;
  }
  @Input() session: SgEntityBasedSession;
  @Input() collateralsToDisplay: CollateralTypesToDisplay;
  @Output() reset = new EventEmitter<CollateralSpecificMatch>();
  @Output() selectionChange = new EventEmitter<LegalEntitySelectionChangeEvent>();

  validationErrorMessages: { -readonly [key in CollateralTypeDto]?: ValidationErrors } = {};
  hasMultipleEntities = false;

  private _locateMatch: LocateMatch;

  ngOnInit(): void {
    this.hasMultipleEntities = this.session?.user?.legalEntities?.length > 1;
  }

  private setValidationErrorMessages(locateMatch: LocateMatch) {
    const { nonCashMatch, cashMatch, minimumAvailableUnits } = locateMatch;
    this.addValidationErrorMessage(nonCashMatch, minimumAvailableUnits);
    this.addValidationErrorMessage(cashMatch, minimumAvailableUnits);
  }

  private addValidationErrorMessage(csMatch: CollateralSpecificMatch, minAvailableUnits: number) {
    if (csMatch) {
      this.validationErrorMessages[csMatch.type] = {
        required: 'Enter units',
        min: `Min size ${minAvailableUnits}`,
        max: `Max size ${csMatch.form.controls.units.defaultValue}`,
      };
    }
  }
}
